// src/routes/CertificateDetailPage.js
import React from "react";
import { useParams } from "react-router-dom";
import { FaExternalLinkAlt, FaSpinner } from "react-icons/fa";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import DetailLayout from "../components/DetailLayout";
import { useData } from "../hooks/useData";
import { getCertificateById } from "../firebase/dataService";

const CertificateDetailPage = () => {
  const { id } = useParams();
  const { data: cert, loading, error } = useData(() => getCertificateById(id), [id]);

  return (
    <div>
      <Navbar />
      {loading ? (
        <div className="container" style={{ padding: "9rem 0", textAlign: "center" }}>
          <FaSpinner className="spin" size={22} />
        </div>
      ) : error || !cert ? (
        <div className="container" style={{ padding: "9rem 0", textAlign: "center" }}>
          <p style={{ color: "var(--text-2)" }}>Certificate not found.</p>
        </div>
      ) : (
        <DetailLayout
          backTo="/certifications"
          backLabel="All certificates"
          coverImage={cert.imgsrc}
          eyebrow="Certificate"
          title={cert.title}
          meta={[cert.completion_date].filter(Boolean)}
          cta={
            cert.verify && (
              <a href={cert.verify} target="_blank" rel="noreferrer" className="btn btn-outline">
                Verify <FaExternalLinkAlt size={12} />
              </a>
            )
          }
        >
          <p>{cert.description}</p>
        </DetailLayout>
      )}
      <Footer />
    </div>
  );
};

export default CertificateDetailPage;
